/**
 * Slim CMS page objects before persisting in fitness plan storage.
 */
export function slimActivity(activity) {
	if (!activity || typeof activity !== 'object') {
		return {};
	}
	const meta = activity.meta && typeof activity.meta === 'object' ? activity.meta : {};
	const slim = {};
	if (activity.id !== undefined) {
		slim.id = activity.id;
	}
	if (meta.type) {
		slim.meta = { type: meta.type };
	}
	const title = activity.title || activity.name;
	if (title) {
		slim.title = title;
		slim.name = title;
	}
	const imageUrl = activity.image_url || activity.main_image_url || activity.square_tile_image_url;
	if (imageUrl) {
		slim.image_url = imageUrl;
	}
	if (activity.duration !== undefined) {
		slim.duration = activity.duration;
	} else if (activity.readtime !== undefined) {
		slim.duration = activity.readtime;
	}
	if (meta.type === 'Custom/SportsType' && activity.subtitle) {
		slim.subtitle = activity.subtitle;
	}
	return slim;
}
